// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3cmnE","consentsList":"PatientConsents_consentsList__yUH9z","consentsListEmpty":"PatientConsents_consentsListEmpty__3MizM"};